import { createSlice } from "@reduxjs/toolkit";

const initialState ={
    currentPosition : null,
    watchPosition : null,
    positionResponse : null,
}

const carrier_current_position = createSlice({
  name: "carrier_current_position",
  initialState,
  reducers: {
    get_current_position : (state, {payload}) => {
        state.currentPosition = payload;
    },
    carrier_watch_position : (state, {payload}) => {
        state.watchPosition = payload;
    },
    carrier_position_response : (state, {payload}) => {
        state.positionResponse = payload
    },
  },
});

export const {
    get_current_position,
    carrier_watch_position,
    carrier_position_response
} = carrier_current_position.actions;

export default carrier_current_position.reducer;
